// Mapeo simple de rutas a imágenes de fondo
const BACKGROUND_MAP: Record<string, string> = {
  "/home": "/images/backgrounds/home.jpg",
  "/monitor": "/images/backgrounds/monitor.png",
  "/map": "/images/backgrounds/monitor.png",
  "/list-alerts": "/images/backgrounds/comunication.jpg",
  "/communication": "/images/backgrounds/communication.jpg",
  "/observatory": "/images/backgrounds/observatory.png",
  "/report": "/images/backgrounds/reportes.jpg",
  "/users": "/images/backgrounds/configuracion.jpg",
};

/**
 * Función simple para cambiar el fondo del body
 */
export function changeBackground(path: string) {
  const backgroundImage = BACKGROUND_MAP[path] || BACKGROUND_MAP["/home"];

  // Aplicar directamente al body con !important
  document.body.style.setProperty(
    "background-image",
    `url('${backgroundImage}')`,
    "important"
  );
  document.body.style.setProperty("background-size", "cover", "important");
  document.body.style.setProperty("background-position", "center", "important");
  document.body.style.setProperty(
    "background-attachment",
    "fixed",
    "important"
  );
  document.body.style.setProperty(
    "background-repeat",
    "no-repeat",
    "important"
  );
  document.body.style.setProperty(
    "background-color",
    "transparent",
    "important"
  );
}
